<template>
  <i :class="flagClass | toLowerCase"></i>
</template>

<script>
export default {
  name: 'Flag',
  props: {
    size: {
      type: [String],
      required: false,
      default: () => 'sm'
    },
    iso: {
      type: [String],
      required: true
    }
  },
  computed: {
    flagClass () {
      return 'flag-' + this.size + '-' + this.iso
    }
  }
}
</script>

<style lang="scss" scoped>

.flag-xs, [class*="flag-xs-"] {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url('https://cdn.rebtel.net/upload/v2/flags/sprite/xs.png');
}

.flag-sm, [class*="flag-sm-"] {
  display: inline-block;
  width: 36px;
  height: 36px;
  background-image: url('https://cdn.rebtel.net/upload/v2/flags/sprite/sm.png');
}

.flag-md, [class*="flag-md-"] {
  display: inline-block;
  width: 48px;
  height: 48px;
  background-image: url('https://cdn.rebtel.net/upload/v2/flags/sprite/md.png');
}

@import "@/assets/styles/flags/flag-xs.scss";
@import "@/assets/styles/flags/flag-sm.scss";
@import "@/assets/styles/flags/flag-md.scss";

</style>



// WEBPACK FOOTER //
// src/components/Flag.vue